import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider } from "@bookips/sds";
import { PriceRow } from "./PriceRow";
export const DiscountSection = (param)=>{
    let { discount  } = param;
    const { baseDiscountAmount =0 , discountedAmount , deliveryFeeCouponAmount  } = discount;
    const totalDiscount = baseDiscountAmount + discountedAmount + deliveryFeeCouponAmount;
    if (totalDiscount <= 0) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                className: "bg-gray-900/10"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsx(PriceRow, {
                        label: "할인",
                        amount: totalDiscount,
                        variant: "body1",
                        isNegative: true
                    }),
                    discountedAmount > 0 && /*#__PURE__*/ _jsx(PriceRow, {
                        label: "상품 쿠폰 할인",
                        amount: discountedAmount,
                        variant: "body2",
                        showIcon: true,
                        isNegative: true
                    }),
                    deliveryFeeCouponAmount > 0 && /*#__PURE__*/ _jsx(PriceRow, {
                        label: "배송비 쿠폰 할인",
                        amount: deliveryFeeCouponAmount,
                        variant: "body2",
                        showIcon: true,
                        isNegative: true
                    })
                ]
            })
        ]
    });
};
